export const getPersonNameError = (fieldName = "Name") =>
  `${fieldName} can contain only letters, numbers, spaces, hyphens (-), and apostrophes (')`;
export const PERSON_NAME_ERROR = getPersonNameError();

export const PERSON_NAME_PATTERN = "^(?=.*\\S)[\\p{L}\\p{M}\\p{N} '-]+$";

const personNameRegex = /^(?=.*\S)[\p{L}\p{M}\p{N} '-]+$/u;

export const isValidPersonName = (value) =>
  typeof value === "string" && value.length > 0 && personNameRegex.test(value);

export const isValidOptionalPersonName = (value) =>
  value == null || value.trim() === "" || isValidPersonName(value);
